export const Wordmark = ({ className = "", voltClass = "text-volt" }) => (
  <span className={`font-display uppercase tracking-wide leading-none ${className}`}>
    Capable <span className={voltClass}>360</span>
  </span>
);
